import { createSlice } from "@reduxjs/toolkit";

export const mockExistedSites = [
  {
    siteId: 'taipei-uuid',
    siteName: 'Taipei',
  },
  {
    siteId: "tainan-uuid",
    siteName: "Tainan",
  },
  {
    siteId: 'kaohsiung-uuid',
    siteName: 'Kaohsiung',
  },
  {
    siteId: "taichung-uuid",
    siteName: "Taichung",
  },
  {
    siteId: "hualien-uuid",
    siteName: "Hualien",
  },
  {
    siteId: "keelung-uuid",
    siteName: "Keelung",
  },
];

export const sitesSlice = createSlice({
  name: "onPremSites",
  initialState: {
    data: {
      sites: [...mockExistedSites],
    }
  },
});

export default sitesSlice.reducer;
